import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import SignupProgress from "../../Components/SignupProgress";
import { Check } from "lucide-react";

const CreateAccountScreen4 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenFour,
    translatedLabels,
    getWellnessCat,
    wellnessCat,
    is4Life,
  } = useContext(GlobalContext);

  const authLabel = translatedLabels?.auth;
  useEffect(() => {
    getWellnessCat();
  }, [getWellnessCat]);

  const handleCheckboxChange = (uuid) => {
    let selectedTopics = Array.isArray(signupData?.wellnessCategory)
      ? [...signupData.wellnessCategory]
      : [];

    if (selectedTopics.includes(uuid)) {
      selectedTopics = selectedTopics.filter((t) => t !== uuid);
    } else {
      selectedTopics.push(uuid);
    }

    updateSignupData("wellnessCategory", selectedTopics);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenFour();
  };

  return (
    <div className="container py-4">
      <SignupProgress currentStep={is4Life ? null : 3} />
      <h3 className="mt-5 text-center">
        {authLabel?.select_wellness_cat?.label_value ||
          "Select your Wellness Interests"}{" "}
        <span className="text-danger">*</span>
      </h3>
      <p className="text-muted text-center fs-14px mb-1">
        {authLabel?.change_it_later?.label_value ||
          "You can change this later in your profile settings."}
      </p>

      <form className="" onSubmit={handleSubmit}>
        <div
          className="d-flex flex-column gap-3 mt-4 px-3 "
          style={{
            maxHeight: "540px",
            overflowY: "auto",
          }}
        >
          {wellnessCat?.list?.map((cat) => {
            const isSelected = signupData?.wellnessCategory?.includes(cat.uuid);
            const borderColor = isSelected
              ? "transparent"
              : "var(--primaryColor)";
            const backgroundColor = isSelected
              ? "var(--primaryColor)"
              : "transparent";
            const checkColor = isSelected ? "white" : "transparent";

            return (
              <div
                key={cat.uuid}
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleCheckboxChange(cat.uuid)}
              >
                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    border: `2px solid ${borderColor}`,
                    backgroundColor,
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <Check size={18} color={checkColor} strokeWidth={3} />
                </div>
                <span className="fw-semibold mb-0">
                  {cat.category_name}
                </span>{" "}
              </div>
            );
          })}
        </div>

        <div className="mt-5 text-center">
          <button className="btn btn-primary">
            {authLabel?.next?.label_value || "Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAccountScreen4;
